const cardsData = [
  {
    image: 'https://readdy.ai/api/search-image?query=Elegant%20ancient%20Chinese%20costume%20drama%20scene%20with%20a%20beautiful%20female%20lead%20in%20flowing%20traditional%20hanfu%2C%20soft%20ethereal%20lighting%20in%20a%20bamboo%20forest%2C%20cinematic%20composition%20with%20warm%20golden%20hour%20backlight%2C%20dreamy%20and%20romantic%20mood%2C%20film%20quality%20photography%2C%20shallow%20depth%20of%20field%2C%20professional%20color%20grading%20with%20warm%20terracotta%20tones&width=600&height=400&seq=card-1-2026&orientation=landscape',
    tag: '古装玄幻',
    title: '2024最强国风古装剧合集',
    desc: '从仙侠奇缘到宫廷权谋，盘点今年不可错过的十部古装大剧，服化道精美绝伦，剧情引人入胜。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Modern%20urban%20romance%20drama%20scene%20with%20a%20couple%20walking%20on%20a%20city%20street%20at%20sunset%2C%20stylish%20contemporary%20fashion%2C%20warm%20golden%20light%20reflecting%20off%20glass%20buildings%2C%20intimate%20and%20romantic%20cinematography%2C%20soft%20bokeh%20background%2C%20Korean%20drama%20aesthetic%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20high%20quality%20film%20still&width=600&height=400&seq=card-2-2026&orientation=landscape',
    tag: '都市爱情',
    title: '今夏必看甜宠都市剧推荐',
    desc: '高颜值CP组合，甜而不腻的都市爱情故事，每一部都让人心动不已，周末刷剧首选清单。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Suspenseful%20crime%20thriller%20drama%20scene%20with%20a%20detective%20in%20a%20dimly%20lit%20interrogation%20room%2C%20dramatic%20shadows%20and%20moody%20atmospheric%20lighting%2C%20tense%20cinematography%20with%20warm%20amber%20key%20light%2C%20professional%20film%20noir%20aesthetic%2C%20high%20contrast%20visuals%2C%20sophisticated%20and%20gritty%20mood%2C%20warm%20brown%20and%20deep%20shadow%20tones&width=600&height=400&seq=card-3-2026&orientation=landscape',
    tag: '悬疑烧脑',
    title: '高分悬疑剧，烧脑停不下来',
    desc: '反转再反转，每一集都让人欲罢不能。精选国内外口碑炸裂的悬疑推理剧，考验你的智商。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Heartwarming%20family%20drama%20scene%20set%20in%20a%20bright%20modern%20apartment%20living%20room%2C%20multi%20generational%20family%20gathering%20around%20a%20dining%20table%2C%20natural%20window%20light%20creating%20warm%20and%20cozy%20atmosphere%2C%20slice%20of%20life%20cinematography%2C%20soft%20color%20palette%20with%20cream%20and%20terracotta%20accents%2C%20professional%20interior%20photography%20style%2C%20emotional%20and%20authentic%20mood&width=600&height=400&seq=card-4-2026&orientation=landscape',
    tag: '家庭温情',
    title: '催泪治愈家庭剧精选',
    desc: '讲述亲情与成长的温暖故事，每看一集都想给家人打个电话。治愈系佳作，抚慰忙碌生活。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Epic%20historical%20war%20drama%20scene%20with%20ancient%20Chinese%20soldiers%20in%20armor%20on%20horseback%20at%20sunset%2C%20vast%20battlefield%20landscape%20with%20dramatic%20sky%2C%20cinematic%20wide%20shot%20composition%2C%20warm%20golden%20and%20amber%20toned%20color%20grading%2C%20heroic%20and%20majestic%20atmosphere%2C%20high%20production%20value%20film%20photography%2C%20epic%20scale%20with%20silhouettes%20against%20the%20horizon&width=600&height=400&seq=card-5-2026&orientation=landscape',
    tag: '史诗巨制',
    title: '大制作历史正剧不容错过',
    desc: '投资过亿、制作精良的历史大剧，还原真实历史风貌，演员阵容强大，堪称国产剧天花板。',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">精选好剧推荐</h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">根据不同类型和热度，为您精心挑选最值得追的热门剧集</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardsData.map((card, i) => (
            <div key={i} className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer">
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) target.parentElement.style.display = 'none';
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-white text-xs font-medium whitespace-nowrap">{card.tag}</span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">{card.title}</h3>
                <p className="text-foreground-500 text-xs leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}